import { Controller } from "@hotwired/stimulus";
import { identifyUser } from '../../../chameleon-config';
import chmln from '@chamaeleonidae/chmln';

export default class extends Controller {
    static values = {
        awsEnv: String
    }

    connect() {
        if (this.awsEnvValue == 'production') {
            this.identifyVisitor();
        }
    }


    identifyVisitor() {
        var uid;
        try { 
            uid = document.cookie.match(/\bvisitor-uid=([a-z0-9-]+)(;|$)/)[1]; 
        } catch(e) {
            document.cookie = 'visitor-uid='+(uid = Math.random().toString(36).substring(2))+'; expires=Tue, Oct 13 2037 04:24:07 UTC; path=/;';
        }

        chmln.identify(uid, { visitor: true });
    }
}
